import * as React from "react";
import { navigate } from "@reach/router";
import { Placeholder } from "kanopi-components/Placeholder";
import { quoteFlowFields } from "kw/api/fragments";
import { useMatchParams } from "kanopi-components/hooks/useMatchParams";
import { usePolicy } from "../hooks/usePolicy";

import {
  QuestionFlowComponent,
  QuestionFlowTypeEnum,
} from "kw/components/QuestionFlow/QuestionFlowComponent";
import { QuoteState } from "kw/api/zeus";

export const UpdatePolicyKnockoutFlowPage = () => {
  const paramsStart = useMatchParams("/policies/:policyId/update/knockout");
  const paramsWithQuestion = useMatchParams(
    "/policies/:policyId/update/knockout/:questionSetKey"
  );
  const policyId = paramsWithQuestion?.policyId || paramsStart?.policyId;
  const prefix = `/policies/${policyId}/update/knockout`;
  const questionSetKey =
    paramsWithQuestion?.questionSetKey || paramsStart?.questionSetKey;

  const [policy, { policyLoading }] = usePolicy(policyId);

  const riskProfileId = policy?.draftUpdate?.riskProfile?.id;
  const startPolicyKnockoutQuery = {
    startKnockouts: [
      {
        input: {
          riskProfileId: riskProfileId,
          questionSetKey: questionSetKey,
        },
      },
      {
        ...quoteFlowFields,
      },
    ],
  };
  const [currentMaxSet, setCurrentMaxSet] = React.useState({
    currentSet: 0,
    maxSets: 1,
  });
  const onCurrentMaxSetChange = (currentSet, maxSets) => {
    const _totalSets = { ...currentMaxSet };
    _totalSets.currentSet = !questionSetKey && currentSet === maxSets ? 0 : currentSet;
    _totalSets.maxSets = maxSets;
    setCurrentMaxSet(_totalSets);
  };
  const onQuestionFlowKnockout = (profile) => {
    if ([QuoteState.KNOCKOUT, QuoteState.REFERRED].includes(profile?.state)) {
      navigate(`/policies/${policyId}/update/referral`);
    }
  };
  return (
    <Placeholder loading={policyLoading || !riskProfileId}>
      <QuestionFlowComponent
        isFlowLayout={false}
        actionFlowType={QuestionFlowTypeEnum.Update}
        prefix={prefix}
        finishedRoute={`/policies/${policyId}/update/confirm`}
        defaultBackLocation={`/policies/${policyId}/update/`}
        actionQuery={startPolicyKnockoutQuery}
        questionFlowResponseKey="startKnockouts"
        questionSetKey={questionSetKey}
        steps={[
          { label: "Your details", complete: true },
          { label: "Your quote", complete: true },
          {
            label: "Review and buy",
            current: currentMaxSet?.currentSet,
            total: currentMaxSet?.maxSets,
            active: true,
          },
        ]}
        onCurrentAndMaxSetChange={onCurrentMaxSetChange}
        onQuestionFlowKnockout={onQuestionFlowKnockout}
      />
    </Placeholder>
  );
};
